import {t} from '../../../common/getTranslations';
import {BatchPaymentCategory} from '../../../common/shared/api/nicolas/vo/enums/BatchPaymentCategory.enum';
import {formatWithCommasAndDefaultHyphen} from '../../../common/shared/utils/formatWithCommasAndDefaultHyphen';
import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {CashContainerProps} from './CashContainerProps.interface';

export function CashContainer({
  cash,
  autoPaymentInfo,
  onClickCashCharge,
  className,
  ...props
}: CashContainerProps) {
  return (
    <div
      className={twMerge(
        'flex w-full flex-row items-center justify-between rounded-4pxr bg-theme-bg-base-alt p-14pxr',
        className
      )}
      {...props}
    >
      <div className="flex flex-col gap-2pxr">
        <Text className="font-large4-bold cursor-default text-ellipsis break-all text-theme-solid-100 line-clamp-1">
          {formatWithCommasAndDefaultHyphen(cash)}
        </Text>
        {autoPaymentInfo?.isBatchPayment && (
          <Text className="font-small2 text-theme-solid-60">
            {autoPaymentInfo.batchPaymentCategory === BatchPaymentCategory.GAtu
              ? t('more_google_auto_use')
              : t('more_cash_pass_vip_use')}
          </Text>
        )}
      </div>
      <div
        onClick={onClickCashCharge}
        className="flex shrink-0 cursor-pointer items-center justify-center rounded-2pxr bg-static-point-yellow py-3pxr px-8pxr"
      >
        <Text className="font-small2 text-static-mono-90">
          {t('common_cash_charge_button')}
        </Text>
      </div>
    </div>
  );
}
